import { ViewChild, Output, EventEmitter, AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UIModalComponent } from './ui-modal.component';

@Component({ template: '' })
export abstract class UIModalBaseComponent implements AfterViewInit, OnChanges {

	@ViewChild(UIModalComponent) modal: UIModalComponent;

	@Input() autoOpen = null;

	// eslint-disable-next-line @angular-eslint/no-output-native
	@Output() close = new EventEmitter<any>();

	constructor() { }

	ngAfterViewInit() {
		this.modal.onClose = this.close;
		if (this.autoOpen) this.open(this.autoOpen);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.modal && changes['autoOpen']) {
			if (changes['autoOpen'].currentValue !== changes['autoOpen'].previousValue) {
				this.open(this.autoOpen);
			}
		}
	}

	abstract open(data: any);

}
